import { useEffect, useState } from 'react';
import { BaseSlide } from '../../../models/slides/BaseSlide';
import useAsyncEffect from 'use-async-effect';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { useWatch } from 'react-hook-form';
import { updatePackage } from './initHelper/package/packageHelper';
import { updateProduct } from './initHelper/product/productHelper';
import { updateEvent } from './initHelper/event/eventHelper';
import { updateCustom } from './initHelper/custom/customHelper';
import { slideDataUpdater } from './initHelper/slideDataUpdater';
import { CustomSlide } from '../../../models/slides/CustomSlide';
import { EventSlide } from '../../../models/slides/EventSlide';
import { ProductSlide } from '../../../models/slides/ProductSlide';
import { PackageSlide } from '../../../models/slides/PackageSlide';

interface useInitCarouselSlidesProps {
  slides: BaseSlide[];
}

export type SlideType = CustomSlide | ProductSlide | EventSlide | PackageSlide;

const useInitCarouselSlides = ({ slides }: useInitCarouselSlidesProps) => {
  const { setValue, control } = useFormContext();
  const slideDatas: SlideType[] = useWatch({ control, name: 'slideDatas' });
  const [slideData, setSlideData] = useState<BaseSlide[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useAsyncEffect(async () => {
    setIsLoading(true);
    try {
      await slideDataUpdater({ slides, setValue });
    } catch (error) {
      throw new Error(error);
    } finally {
      setIsLoading(false);
    }
  }, [slides.length]);

  useEffect(() => {
    if (!slideDatas) return;
    setSlideData(slideDatas);
  }, [slideDatas]);

  useAsyncEffect(async () => {
    for (let index = 0; index < slides.length; index++) {
      const slide = slides[index];
      const previousSlide = slideData[index];

      if (previousSlide && JSON.stringify(previousSlide) !== JSON.stringify(slide)) {
        switch (slide.type) {
          case 'CUSTOM':
            updateCustom({ slide, setValue, index });
            break;
          case 'PACKAGE':
            updatePackage({ slide, setValue, index });
            break;
          case 'PRODUCT':
            updateProduct({ slide, setValue, index });
            break;
          case 'EVENT':
            updateEvent({ slide, setValue, index });
            break;
          default:
            break;
        }
      }
    }

    setSlideData(slides);
  }, [slides]);

  return { slideData, isLoading };
};

export default useInitCarouselSlides;
